import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { useState } from 'react';

export function BackfillNov4Event() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const backfillEvent = async () => {
    setLoading(true);
    try {
      // Insert Nov 4 event with same properties as Nov 11 event
      const { data, error } = await supabase
        .from('events')
        .insert([{
          title: "Leo's Training",
          event_date: '2025-11-04',
          start_time: '2025-11-04T09:00:00+00:00',
          end_time: '2025-11-04T12:00:00+00:00',
          location_name: "Leo's House",
          location_latitude: 1.3596145143465765,
          location_longitude: 103.84423078475682,
          location_radius: 100,
          requires_gps: true,
          created_by: '0fd0fde3-4fbf-473c-b1cd-dc88bd020339',
          is_active: true,
          event_type: 'compulsory',
          audience_mode: 'organizational',
          scope: 'agency',
          category: 'client_events',
          district_id: '69cfd382-f579-49cc-8c60-bd90641fba5e',
          agency_id: '9e2ef918-2f2c-4dc1-8079-17092dcaf914',
          organizational_criteria: {
            agencies: ['9e2ef918-2f2c-4dc1-8079-17092dcaf914'],
            consultantTypes: [],
            containsText: '',
            districts: [],
            logic: 'OR',
            roles: []
          },
          series_id: '182c92bf-b884-451d-b94a-fbe95e6277a0',
          is_recurring: false,
          recurrence_pattern: null
        }])
        .select();

      if (error) throw error;

      toast.success('Nov 4 event added successfully!');
      setDone(true);
      console.log('Inserted event:', data);
    } catch (error) {
      console.error('Error backfilling event:', error);
      toast.error('Failed to add Nov 4 event');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <Card className="max-w-md mx-auto mt-8">
        <CardContent className="pt-6 text-center">
          <p className="text-green-600 font-semibold">✓ Nov 4 event added successfully!</p>
          <p className="text-sm text-muted-foreground mt-2">You can now refresh the calendar to see it.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="max-w-md mx-auto mt-8">
      <CardHeader>
        <CardTitle>Backfill Nov 4 Event</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-4">
          This will add the missing Nov 4 occurrence to Leo's Training series.
        </p>
        <Button onClick={backfillEvent} disabled={loading}>
          {loading ? 'Adding...' : 'Add Nov 4 Event'}
        </Button>
      </CardContent>
    </Card>
  );
}
